<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-x-2">
        <base-button
          :to="{ name: 'kasir.tarik.saldo-sisa-pembayaran-sc.tambah' }"
        >
          <Icon icon="heroicons:plus" />
          Tambah
        </base-button>
      </div>
      <div>
        <datatable
          :columns="columns"
          :data="balanceTrxes.data"
          :scroll-x="false"
          :total="balanceTrxes.meta.page.total"
          :perPage="balanceTrxes.meta.page.perPage"
          :currentPage="balanceTrxes.meta.page.currentPage"
          @pagechanged="onPageChanged"
        >
          <template v-slot:tbody="{ classes }">
            <tr
              v-for="(balanceTrx, index) in balanceTrxes.data"
              :key="balanceTrx.id"
              :class="[
                classes.tr,
                index % 2 === 0 ? 'bg-white' : 'bg-gray-50',
                'bg-white hover:bg-green-100',
              ]"
            >
              <td :class="[classes.td]">
                <span class="font-bold text-gray-900">{{
                  getSingleIncluded(
                    balanceTrxes,
                    balanceTrx.relationships.office.data.id
                  ).attributes.code
                }}</span>
              </td>
              <td :class="classes.td">
                {{ balanceTrx.attributes.createdAt | formatDate }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  Math.abs(balanceTrx.attributes.overpayment_amount)
                    | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-center']">
                <base-badge
                  :color="balanceTrx.attributes.is_approved ? 'green' : 'red'"
                  :class="{
                    'cursor-pointer': !balanceTrx.attributes.is_approved,
                  }"
                  @click="onOpenApprove(balanceTrx)"
                >
                  {{
                    balanceTrx.attributes.is_approved ? 'Valid' : 'Belum Valid'
                  }}
                </base-badge>
              </td>
            </tr>
          </template>
        </datatable>
      </div>
    </div>
    <loading v-if="loading" />
    <base-confirm
      icon-type="badge"
      type="success"
      title="Konfirmasi Tarik Saldo Sisa Pembayaran SC"
      message="Tekan tombol konfirmasi untuk mengonfirmasi tarik saldo sisa pembayaran SC"
      confirm-text="Konfirmasi"
      :visible="confirmApprove.visible"
      @close="confirmApprove.visible = false"
      @confirmed="onApprove"
    />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: {
    BaseConfirm,
  },
  data() {
    return {
      balanceTrxes: {
        data: [],
        meta: {
          page: {
            total: 0,
          },
        },
      },
      confirmApprove: {
        visible: false,
        id: null,
      },
      loadingBalanceTrxes: false,
      loadingApproveBalanceTrx: false,
    };
  },
  computed: {
    columns() {
      return [
        { id: 'office_code', name: 'Kode Stockist Center' },
        { id: 'createdAt', name: 'Tanggal Top Up' },
        { id: 'amount', name: 'Jumlah Tarik', theadClass: 'text-right' },
        { id: 'status', name: 'Status', theadClass: 'text-center' },
      ];
    },
    loading() {
      return this.loadingBalanceTrxes || this.loadingApproveBalanceTrx;
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadBalanceTrxes(params = {}) {
      this.loadingBalanceTrxes = true;

      const [res, error] = await this.request('/api/v1/balance-trxes', {
        params: {
          'page[size]': 5,
          'sort': '-id',
          'filter[trx_type]': 'withdraw_overpayment_balance',
          include: 'office',
          'fields[balance-trxes]':
            'office,createdAt,overpayment_amount,is_approved',
          'fields[offices]': 'code',
          ...params,
        },
      });

      if (!error) {
        this.balanceTrxes = res;
      }

      this.loadingBalanceTrxes = false;
    },
    onOpenApprove(balanceTrx) {
      this.confirmApprove.id = balanceTrx.id;
      this.confirmApprove.visible = true;
    },
    async onApprove() {
      this.loadingApproveBalanceTrx = true;

      const [, error] = await this.request(
        `/api/v1/balance-trxes/${this.confirmApprove.id}/-actions/approve`,
        {
          method: 'patch',
        }
      );

      if (error) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(error),
        });
      } else {
        this.confirmApprove.visible = false;

        this.loadBalanceTrxes();
      }

      this.loadingApproveBalanceTrx = false;
    },
    onPageChanged(page) {
      this.loadBalanceTrxes({
        'page[number]': page,
      });
    },
  },
  created() {
    this.loadBalanceTrxes();
  },
};
</script>
